import type { FaireProductEntity } from "../../entity_types/product";

export const p_5wuit1rrfz: FaireProductEntity = {
  token: "p_5wuit1rrfz",
  type: "product",
  name: "Hello Gorgeous Travel Make Up Pouch",
  brandToken: "b_191br80oqs",
  brandName: "The Cotton & Canvas Co.",
  imageUrl: "https://cdn.faire.com/fastly/83826ecbc287fccf5f590a61819972f392b7e5371fb157ee65da0b14bd478409.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a4a001ad24f9e41b806ba3313a9d6a8fd40d5f5386f01f03013f7b3af163dff8.jpeg"
  ],
  priceDollars: 7.5,
  description: "Our cosmetic bags make the cutest little pouch for all your makeup essentials! Perfect for travel, these trendy makeup bags can not only store your cosmetics but can serve as an everyday bag for your passport, iPod, headphones, cell phone, pencils, sunglasses and keys. These adorable travel bags make great Valentine's Day and Mother's Day gifts!\n\n• Material: 100% Cotton Canvas Fabric.\n• Size: 9\" W x 6\" H.\n• Reusable and Eco-friendly.\n• Made in the USA.\n\nSpot clean with warm water and mild detergent (do not machine wash)",
  tags: [],
  msrpDollars: 14.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:03:43.219Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
